import { RestClientService } from '../rest-client.service';
import { ProfileDataService } from './profile-data.service';
import { ObservableResult } from '../../models/result.model';
import { IAbsenceTypes, ProfileData, UserUpdateData } from '../../models/profile/profile.model';
import { IUser, ProfileStudio } from '../../models/leads/leads.model';

export class ApiProfileDataService implements ProfileDataService {

  constructor(
    private client: RestClientService
  ) {
  }

  getUserProfile(): ObservableResult<ProfileData> {
    const url = '/api/UserProfile';
    const method = 'GET';

    return this.client.requestWithConstUrl<ProfileData>(method, url);
  }

  updateUserProfile(profileData: UserUpdateData): ObservableResult<void> {
    const url = '/api/UserProfile';
    const method = 'PUT';

    return this.client.requestWithConstUrl(method, url, profileData);
  }

  getAbsenceTypes(): ObservableResult<IAbsenceTypes[]> {
    const url = '/api/UserProfile/AbsenceTypes';
    const method = 'GET';

    return this.client.requestWithConstUrl<IAbsenceTypes[]>(method, url);
  }

  getSubordinates(): ObservableResult<IUser[]> {
    const url = '/api/UserProfile/Subordinates';
    const method = 'GET';

    return this.client.requestWithConstUrl<IUser[]>(method, url);
  }

  getSubstitutes(): ObservableResult<IUser[]> {
    const url = '/api/UserProfile/Substitutes';
    const method = 'GET';

    return this.client.requestWithConstUrl<IUser[]>(method, url);
  }

  getStudios(): ObservableResult<ProfileStudio[]> {
    const url = '/api/UserProfile/Studios';
    const method = 'GET';

    return this.client.requestWithConstUrl<ProfileStudio[]>(method, url);
  }
}
